import React, { useState, useEffect } from 'react';
import { 
    TableContainer,
    TableRow,
    TableCell,
    Table,
    TableBody,
    TableFooter,
    TablePagination,
    IconButton,
    Icon,
    InputLabel,
    MenuItem,
    Select
  } from '@material-ui/core';
import { TableHeader, RowItem, PaperTable, RowTable, Loading, CustomFormControl, CustomSpan, CustomIconButton, CustomIcon } from './styles';
import Api from '../../plugins/Api';
import utils from '../../plugins/utils';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function TableResult({ data, logado }) {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [pagina, setPagina] = useState(0);
  const [linhasPorPagina, setLinhasPorPagina] = useState(25);
  const [loading, setLoading] = useState(false);
  const [idDownload, setIdDownload] = useState('');
  const headerColumns = [
    {
      title: 'Nome Documento',
      label: 'Documento',
      value: 'nome',
      icon: 'arrow_downward',
      active: false,
      ordenable: true
    },
    {
      title: 'Nome do Interessado ou do órgão consulente',
      label: 'Orgão',
      value: 'interessado',
      icon: 'arrow_downward',
      active: false,
      ordenable: true
    },
    {
      title: 'Número do(a) parecer/manifestação',
      label: 'N° Parecer',
      value: 'emitenteNr',
      icon: 'arrow_downward',
      active: false,
      ordenable: true
    },
    {
      title: 'Assunto',
      label: 'Assunto',
      value: 'assunto',
      icon: 'arrow_downward',
      active: false,
      ordenable: true
    },
    {
      title: 'Decisão GAB nº',
      label: 'N° Decisão',
      value: 'nrDecisao',
      icon: 'arrow_downward',
      active: false,
      ordenable: true
    },
    {
      title: 'Data',
      label: 'Data',
      value: 'data',
      icon: 'arrow_downward',
      active: false,
      ordenable: true
    }];
  if(logado) {
    headerColumns.push(
      {
        title: 'Criador',
        label: 'Criador',
        value: 'criador',
        icon: 'arrow_downward',
        active: false,
        ordenable: true
      }
    );
    headerColumns.push(
      {
        title: 'Data Modificação',
        label: 'Data Modificação',
        value: 'dataModificacao',
        icon: 'arrow_downward',
        active: false,
        ordenable: true
      }
    );
  }

  const [ordenarPor, setOrdenarPor] = useState({field: '', crescente: null});
  const [result, setResult] = useState(data);

  const handleChangePage = async (event, novaPagina) => {
    await setPagina(novaPagina);
    await window.scrollTo(0, document.body.scrollHeight)
  };

  const handleChangeRowsPerPage = async (event) => {
    await setLinhasPorPagina(+event.target.value);
    await setPagina(0);
    await window.scrollTo(0, document.body.scrollHeight)
  };

  const handleOrderChanged = () => {
    handleColumnSortClick(ordenarPor.field);
  }

  const handleSelectedOrder = (event) => {
    handleColumnSortClick(event.target.value);
  };

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setPagina(0);
    setResult(data);
  }, [data])
  const downloadPdf = async (documento) => {
    setLoading(true);
    setIdDownload(documento.id);
    await Api.download('GET', `${process.env.REACT_APP_BASEURL_API}/download/${documento.id}`, 'application/pdf', documento.nome)
      .then(response => {
        setLoading(false);
  })
  }
  const handleColumnSortClick = (field) => {
    const ordenar = {
      field: field,
      crescente: ordenarPor.field !== field ? true : utils.trueFalseNull(ordenarPor.crescente)
    }
    setPagina(0);
    setOrdenarPor(ordenar);
    ordenar.crescente !== null ? setResult(utils.sortTableResult([...data], ordenar.field, ordenar.crescente)) : setResult(data)
  }

  return (
    <TableContainer component={PaperTable} elevation={2} >
      <Table>
        <TableHeader>
        {windowDimensions.width >= 960 && <>
          <TableRow>
              {headerColumns.map(column => 
                <TableCell key={column.title}>{column.title}
                  <>
                    <CustomIconButton onClick={() => handleColumnSortClick(column.value)}>
                      <CustomIcon cor={ordenarPor.crescente !== null && column.value === ordenarPor.field}>{utils.getIconSort(column.value === ordenarPor.field ? ordenarPor.crescente : null)}</CustomIcon>
                    </CustomIconButton>
                  </>  
                </TableCell>
                
              )}
              <TableCell>Download</TableCell>
          </TableRow>
        </>}
        {windowDimensions.width < 960 && <>
          <TableRow>
            <TableCell>
              <CustomSpan>
                Documento(s)
              </CustomSpan>
                <CustomFormControl 
                variant="outlined">
                <InputLabel id="demo-simple-select-outlined-label">Ordenar por</InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={ordenarPor.field}
                  onChange={handleSelectedOrder}
                  label="Ordenar Por"
                >
                  {headerColumns.filter((e) => {return e.label}).map(column =>
                    <MenuItem key={column.value} value={column.value}>
                      {column.label}   
                    </MenuItem>
                  )}
                </Select>
              </CustomFormControl>
              {ordenarPor.field && <>
                  <IconButton onClick={() => handleOrderChanged()}>
                    <CustomIcon cor={ordenarPor.crescente !== null}>{utils.getIconSort(ordenarPor.crescente)}</CustomIcon>
                  </IconButton>
                </>
                }
            </TableCell>
          </TableRow>
        </>}
        </TableHeader>
        <TableBody>
          {result.length > 0 && windowDimensions.width >= 960 && result.slice(pagina * linhasPorPagina, pagina * linhasPorPagina + linhasPorPagina).map(linha => (
            <TableRow key={linha.id}>
              <TableCell>{linha.nome}</TableCell>
              <TableCell>{linha.interessado}</TableCell>
              <TableCell>{linha.emitenteNr}</TableCell>
              <TableCell>{linha.assunto}</TableCell>
              <TableCell>{linha.nrDecisao}</TableCell>
              <TableCell>{linha.data ? `${linha.data.split('-')[2].substr(0, 2)}/${linha.data.split('-')[1]}/${linha.data.split('-')[0]}` : ''}</TableCell>
              {logado && <>
                <TableCell>{linha.criador}</TableCell>
                <TableCell>{linha.dataModificacao ? `${linha.dataModificacao.split('-')[2].substr(0, 2)}/${linha.dataModificacao.split('-')[1]}/${linha.dataModificacao.split('-')[0]}` : ''}</TableCell>
              </>}
              <TableCell align="center">
                {loading && idDownload === linha.id ?
                  <Loading size={24} /> :
                  <IconButton onClick={() => downloadPdf(linha)}><Icon>get_app</Icon></IconButton>
                }
              </TableCell>
            </TableRow>
          ))}
          {result.length > 0 && windowDimensions.width < 960 && result.slice(pagina * linhasPorPagina, pagina * linhasPorPagina + linhasPorPagina).map(linha => (
            <TableRow key={linha.id}>
              <TableCell>
                <RowTable>
                  <RowItem><b>Nome</b>: {linha.nome} </RowItem>
                  <RowItem><b>Interessado/Órgão</b>: {linha.interessado} </RowItem>
                  <RowItem><b>Nº Parecer</b>: {linha.emitenteNr} </RowItem>
                  <RowItem><b>Assunto</b>: {linha.assunto}</RowItem>
                  <RowItem><b>Decisão Nº</b>: {linha.nrDecisao} </RowItem>
                  <RowItem><b>Data</b>: {linha.data ? `${linha.data.split('-')[2].substr(0, 2)}/${linha.data.split('-')[1]}/${linha.data.split('-')[0]}` : ''} </RowItem>
                  {logado && <>
                    <RowItem><b>Criador</b>: {linha.criador} </RowItem>
                    <RowItem><b>Data Modificação</b>: {linha.dataModificacao ? `${linha.dataModificacao.split('-')[2].substr(0, 2)}/${linha.dataModificacao.split('-')[1]}/${linha.dataModificacao.split('-')[0]}` : ''} </RowItem>
                  </>}
                 
                  <RowItem><b>Download</b>:
                    {loading && idDownload === linha.id ?
                      <Loading size={24} /> :
                      <IconButton onClick={() => downloadPdf(linha)}><Icon>get_app</Icon></IconButton>
                    }
                  </RowItem>
                </RowTable>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={windowDimensions.width >= 960 ? logado ? 9 : 7 : 1}
              count={result.length}
              rowsPerPage={linhasPorPagina}
              page={pagina}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage="Linhas por Página"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
              nextIconButtonText="Próxima página"
              backIconButtonText="Página anterior"
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}

export default TableResult;